import { render, staticRenderFns } from "./TeamCardParts.vue?vue&type=template&id=418c6833&scoped=true"
import script from "./TeamCardParts.vue?vue&type=script&lang=ts"
export * from "./TeamCardParts.vue?vue&type=script&lang=ts"
import style0 from "./TeamCardParts.vue?vue&type=style&index=0&id=418c6833&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418c6833",
  null
  
)

export default component.exports